import { UrlConstants } from "../url.constants";
export class ApiSetFieldConstants {
    static URL = UrlConstants.API_V2 + "SetField";
    static FUNCTION_GET_VALUES = "GetFieldValues";
    static FUNCTION_GET_MULTIPLE_ITEMS_LIST = "GetMultipleItemsList";
    static FUNCTION_GET_SEQUENCE_NUMBER = "GetSequenceNumber";
}
